<div class="info-panel__container d-flex align-items-start p-2">
  <lui-avatar
    color="primary"
    class="me-1 mt-_5"
    [size]="20"
    [matTooltip]="props.tooltip"
    [useClickListener]="true"
  >
    <mat-icon svgIcon="i"></mat-icon>
  </lui-avatar>
  <span [innerHTML]="props.label"></span>
</div>
